import { useState, useEffect } from 'react';
import { deviceDetectionService } from '../utils/deviceDetectionService';

const DeviceGuard = ({ children }) => {
  const [isAllowedDevice, setIsAllowedDevice] = useState(true);

  useEffect(() => {
    const checkDevice = () => {
      const info = deviceDetectionService.getDeviceInfo();
      setIsAllowedDevice(!info.isDesktop);
    };

    checkDevice();
    window.addEventListener('resize', checkDevice);

    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  if (!isAllowedDevice) {
    return (
      <div className="device-restriction-screen">
        <div className="restriction-content">
          <div className="restriction-icon">
            <i className="bi bi-phone" style={{ fontSize: '4rem' }}></i>
          </div>
          <h1>Mobile Only Application</h1>
          <p>
            This application is designed exclusively for mobile devices.
            Please access it from your smartphone or tablet.
          </p>
        </div>
      </div>
    );
  }

  return children;
};

export default DeviceGuard;